import React from "react";
import ImageUploadField from "./ImageUploadField";
import VideoUploadField from "./VideoUploadField";
import { THEME_PRESETS } from "../utils/businessThemes";

const GALLERY_CATEGORIES = [["public", "Public Events"], ["speeches", "Speeches"], ["meetings", "Meetings"]];
const VIDEO_CATEGORIES = [["speeches", "Speeches"], ["interviews", "Interviews"], ["campaigns", "Campaigns"], ["press", "Press"]];
const emptyPhoto = { url: "", title: "", title_np: "", category: "public" };
const emptyVideo = { title: "", title_np: "", description: "", description_np: "", url: "", thumbnail: "", category: "speeches" };

export default function PoliticalGalleryTab({ form, set, gallery, setGallery, videos, setVideos, personaluid }) {
    const upd = (list, setList, i, patch) => {
        const c = [...list];
        c[i] = { ...c[i], ...patch };
        setList(c);
    };
    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            {/* ---------- Photo gallery ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Photo Gallery <small className="text-muted fw-normal">(category + caption; visitors can filter and open a lightbox)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setGallery([...gallery, { ...emptyPhoto }])}>
                        <i className="bi bi-plus-lg me-1" />Add Photo
                    </button>
                </div>
                <div className="card-body">
                    {gallery.length === 0 ? (
                        <p className="text-muted mb-0">No photos in gallery yet.</p>
                    ) : (
                        <div className="row g-3">
                            {gallery.map((g, i) => (
                                <div className="col-md-4" key={i}>
                                    <div className="border rounded p-2 h-100">
                                        <ImageUploadField value={g.url} onChange={(v) => upd(gallery, setGallery, i, { url: v })} purpose="gallery" personaluid={personaluid} placeholder="Upload photo" />
                                        <select className="form-select form-select-sm mt-2" value={g.category || "public"} onChange={(e) => upd(gallery, setGallery, i, { category: e.target.value })}>
                                            {GALLERY_CATEGORIES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                        </select>
                                        <input className="form-control form-control-sm mt-2" placeholder="Caption" value={g.title || ""} onChange={(e) => upd(gallery, setGallery, i, { title: e.target.value })} />
                                        <input className="form-control form-control-sm mt-2" placeholder="क्याप्सन (Nepali)" value={g.title_np || ""} onChange={(e) => upd(gallery, setGallery, i, { title_np: e.target.value })} />
                                        <button type="button" className="btn btn-sm btn-outline-danger mt-2 w-100" onClick={() => removeAt(gallery, setGallery, i)}>
                                            <i className="bi bi-trash me-1" />Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* ---------- Videos ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Videos <small className="text-muted fw-normal">(YouTube link or uploaded file; plays in a pop-up)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setVideos([...videos, { ...emptyVideo }])}>
                        <i className="bi bi-plus-lg me-1" />Add Video
                    </button>
                </div>
                <div className="card-body">
                    {videos.length === 0 ? (
                        <p className="text-muted mb-0">No videos yet.</p>
                    ) : videos.map((v, i) => (
                        <div className="border rounded p-3 mb-3" key={i}>
                            <div className="row g-2">
                                <div className="col-md-8">
                                    <label className="form-label small text-muted">YouTube link</label>
                                    <input className="form-control form-control-sm" placeholder="https://www.youtube.com/watch?v=..." value={v.url || ""} onChange={(e) => upd(videos, setVideos, i, { url: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted">Category</label>
                                    <select className="form-select form-select-sm" value={v.category || "speeches"} onChange={(e) => upd(videos, setVideos, i, { category: e.target.value })}>
                                        {VIDEO_CATEGORIES.map(([val, l]) => <option key={val} value={val}>{l}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-1 d-flex align-items-end">
                                    <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(videos, setVideos, i)}><i className="bi bi-trash" /></button>
                                </div>
                                <div className="col-12">
                                    <label className="form-label small text-muted">…or upload a video file</label>
                                    <VideoUploadField value={/^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//i.test(v.url || "") ? "" : v.url} onChange={(val) => upd(videos, setVideos, i, { url: val })} personaluid={personaluid} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Title</label>
                                    <input className="form-control form-control-sm" value={v.title || ""} onChange={(e) => upd(videos, setVideos, i, { title: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">शीर्षक (Nepali)</label>
                                    <input className="form-control form-control-sm" value={v.title_np || ""} onChange={(e) => upd(videos, setVideos, i, { title_np: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Description</label>
                                    <input className="form-control form-control-sm" value={v.description || ""} onChange={(e) => upd(videos, setVideos, i, { description: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">विवरण (Nepali)</label>
                                    <input className="form-control form-control-sm" value={v.description_np || ""} onChange={(e) => upd(videos, setVideos, i, { description_np: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Thumbnail <span className="text-muted">(optional — YouTube videos get one automatically)</span></label>
                                    <ImageUploadField value={v.thumbnail || ""} onChange={(val) => upd(videos, setVideos, i, { thumbnail: val })} purpose="gallery" personaluid={personaluid} placeholder="Upload thumbnail" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ---------- Social ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Social Links</div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label small">Facebook URL</label>
                            <input className="form-control form-control-sm" placeholder="https://facebook.com/..." value={form.linkfacebook || ""} onChange={(e) => set("linkfacebook", e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Instagram URL</label>
                            <input className="form-control form-control-sm" placeholder="https://instagram.com/..." value={form.linkinstagram || ""} onChange={(e) => set("linkinstagram", e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Twitter / X URL</label>
                            <input className="form-control form-control-sm" placeholder="https://twitter.com/..." value={form.linktwitter || ""} onChange={(e) => set("linktwitter", e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">LinkedIn URL</label>
                            <input className="form-control form-control-sm" placeholder="https://linkedin.com/..." value={form.linklinkedin || ""} onChange={(e) => set("linklinkedin", e.target.value)} />
                        </div>
                        <div className="col-12">
                            <label className="form-label small">YouTube Channel / Featured Video Link</label>
                            <input className="form-control form-control-sm" placeholder="https://www.youtube.com/..." value={form.youtube_link || ""} onChange={(e) => set("youtube_link", e.target.value)} />
                            <small className="form-text text-muted mt-1">Shown as a YouTube icon in the footer. If you haven't added any videos above, a watch link here appears as a single video.</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* ---------- Theme ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Website Theme Colour</div>
                <div className="card-body">
                    <p className="text-muted small mb-2">Choose a colour theme for your political website:</p>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        {THEME_PRESETS.map((t) => {
                            const on = (form.theme_color || "classic-navy") === t.key;
                            return (
                                <button key={t.key} type="button" title={t.label} onClick={() => set("theme_color", t.key)}
                                    style={{ width: 40, height: 40, borderRadius: 8, border: "none", background: `linear-gradient(135deg, ${t.brand}, ${t.brand2})`,
                                        outline: on ? `3px solid ${t.accent}` : "2px solid transparent", outlineOffset: 2, cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", transition: "all 0.2s" }}>
                                    {on && <i className="bi bi-check-lg" />}
                                </button>
                            );
                        })}
                    </div>
                    <div className="form-text">
                        <b>Selected:</b> {THEME_PRESETS.find((t) => t.key === form.theme_color)?.label || "Classic Navy"} — this changes the colours on your live political website.
                    </div>
                </div>
            </div>
        </div>
    );
}